// @flow
import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';

// Material
import Slide from '@material-ui/core/Slide';
import Container from '@material-ui/core/Container';

// Custom
import PricingBlock from '../components/ui/PricingBlock';
import TrainResultsList from '../components/ui/TrainResultsList';
import SearchForm from '../components/ui/SearchForm';
import { SectionTitle, SectionLabel, BoldText } from '../components/text';
import {
  TopHero,
  ContentWithPadding,
  ResultsWrapper,
  OverlappingSectionBlock,
} from '../components/layout';
import LoadingIndicator from '../components/ui/LoadingIndicator';
import EmptyState from '../components/ui/EmptyState';

// Data
import { defaultSeoConfig } from '../components/helpers/defaultSeoConfig';

// Context & Actions
import { TrainsContext, actionTypes } from '../TrainsContext';

function getTrainsFromNaritaData() {
  return axios.get('db/from_narita_timetable_data.json');
}

function getTrainsToNaritaData() {
  return axios.get('db/to_narita_timetable_data.json');
}

const Home = () => {
  const { state, dispatch } = useContext(TrainsContext);
  const hasResults = state.filteredTrains.length > 0;

  useEffect(() => {
    axios
      .all([getTrainsFromNaritaData(), getTrainsToNaritaData()])
      .then(
        axios.spread(function(fromNarita, toNarita) {
          dispatch({
            type: actionTypes.FETCH_TRAINS_FROM_NARITA,
            payload: fromNarita.data.timetables,
          });
          dispatch({
            type: actionTypes.FETCH_TRAINS_TO_NARITA,
            payload: toNarita.data.timetables,
          });
        }),
      )
      .catch(error => console.log(error));
  }, [dispatch]);

  useEffect(() => {
    if (state.trainsFromNarita.length > 0) {
      dispatch({ type: actionTypes.UPDATE_FILTERED_TRAINS });
      dispatch({ type: actionTypes.SET_LOADING, payload: false });
    }
  }, [dispatch, state.trainsFromNarita]);

  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:url" content={defaultSeoConfig.url} />
        <link rel="canonical" href={defaultSeoConfig.url} />
      </Helmet>
      <TopHero>
        <Container maxWidth="lg">
          <Slide direction="right" in={true} mountOnEnter unmountOnExit>
            <ContentWithPadding py="16">
              <SectionLabel>Search train times and train routes</SectionLabel>
              <SectionTitle>
                Ride the <BoldText>Narita Express</BoldText> to{' '}
                <BoldText>Tokyo</BoldText>
              </SectionTitle>
            </ContentWithPadding>
          </Slide>
          <SearchForm />
        </Container>
      </TopHero>
      <Container maxWidth="lg">
        <OverlappingSectionBlock
          offset={hasResults && !state.isLoading ? '-50' : '0'}
        >
          <ResultsWrapper>
            {state.isLoading ? (
              <LoadingIndicator loadingMsg="Searching for trains..." />
            ) : (
              <React.Fragment>
                {hasResults ? <TrainResultsList /> : <EmptyState />}
              </React.Fragment>
            )}
          </ResultsWrapper>
        </OverlappingSectionBlock>
        <PricingBlock />
      </Container>
    </React.Fragment>
  );
};

export default Home;
